import { useCallback, useMemo, useState } from 'react'
import { LOCAL_STORAGE } from 'app/localStorageManager'

/**
 * The `useCurrency` hook
 *
 * @returns {object} the context object
 */
function useCurrency () {
  const [preferredCurrency, setPreferredCurrencyInternal] = useState(
    localStorage.getItem(LOCAL_STORAGE.preferredCurrency) || 'USD'
  )

  /**
   * Set the preferred currency
   */
  const setPreferredCurrency = useCallback(currency => {
    const nextCurrency = currency === 'MATIC' ? 'MATIC' : 'USD'

    localStorage.setItem(LOCAL_STORAGE.preferredCurrency, nextCurrency)
    setPreferredCurrencyInternal(nextCurrency)
  }, [])

  /**
   * Memo: The context object
   */
  const ctx = useMemo(
    () => ({
      preferredCurrency,
      setPreferredCurrency
    }),
    [preferredCurrency]
  )

  return ctx
}

// Export
export default useCurrency
